module.exports = __webpack_public_path__ + "img/box9-img-1.628274b4.png";